import Icon from 'snippets/icon/icon'

function CustomModalDialog({
  header,
  content,
  footer,
  id,
  type = 'modal',
  classClose = 'top-3 right-4 h-8 w-8 p-2 md:top-4 md:right-6',
  classMain = '',
  classContent = '',
  classHeader = '',
  title,
  classIcon = 'h-4 w-4 text-grey-500',
  className = '',
  scrollTarget = '.modal-dialog-inner'
}) {
  return (
    <modal-dialog className={className} data-target={id} data-type={type} data-scroll-target={scrollTarget}>
      <div
        className={`modal-dialog-content js-content-modal-dialog relative ${classMain}`}
        aria-modal="true"
        role="dialog"
        aria-label={title && title}
      >
        <div className={`${classHeader}`}>
          {header}
          <button type="button" className={`js-close-modal-dialog absolute ${classClose}`} aria-label="close modal">
            <Icon name="icon-close" viewBox="0 0 20 20" className={classIcon} />
          </button>
        </div>
        <div className={`modal-dialog-inner ${classContent}`}>{content}</div>
        {footer}
      </div>
    </modal-dialog>
  )
}

export default CustomModalDialog
